import React from 'react';
import { Fab } from '@mui/material';
import { KeyboardArrowDown as ArrowDownIcon } from '@mui/icons-material';

const ScrollDownButton = ({ onClick, isMobile = false }) => {
  if (!isMobile) {
    return null; // Only show on mobile
  }

  const handleScroll = () => {
    window.scrollBy({
      top: window.innerHeight * 0.8,
      behavior: 'smooth'
    });
  };

  return (
    <Fab
      size="small"
      onClick={handleScroll}
      sx={{
        position: 'fixed',
        bottom: 80,
        right: 20,
        backgroundColor: '#FFFFFF',
        color: '#6B7280',
        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
        zIndex: 999,
        '&:hover': {
          backgroundColor: '#F8F9FA',
          color: '#000000'
        }
      }}
    >
      <ArrowDownIcon />
    </Fab>
  );
};

export default ScrollDownButton;